import React from 'react'
import { CATEGORY_DETAIL } from '../urls'
import { useDeleteRequest } from '../hooks/request'
import CategoryUpdate from './CategoryUpdate'
import { useModal } from '../hooks/modal'
import { format } from '../utils/number'
import { getDateTime } from '../utils/date'
import Loader from './common/Loader'

export default function CategoryItem({ categories, item, index }) {
    const categoryRemove = useDeleteRequest({ url: CATEGORY_DETAIL.replace('{id}', item.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await categoryRemove.request()
            categories.request()
        }
    }

    const [showUpdateModal, setShowUpdateModal] = useModal(<CategoryUpdate reload={categories} item={item} hideModal={() => setShowUpdateModal()} />)

    return (
        <tr>
            <td>
                {index + 1}
            </td>
            <td>
                {format(item.name)}
            </td>

            <td>
                {getDateTime(item.createdAt)}
            </td>
            <td>
                {getDateTime(item.updatedAt)}
            </td>

            <td>
                <div className="is-pulled-right">
                    {!categories.loading ? (
                        <i onClick={onDelete} className="icon pointer ion-md-trash" />
                    ) : <Loader className="icon" />}

                    <i onClick={showUpdateModal} className="icon pointer ion-md-create" />

                </div>
            </td>
        </tr>
    )
}
